import { Component, OnInit } from '@angular/core';
import { PushHistoryItemModel } from 'src/app/models/push/history-item.model';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePagedPage } from '../base-paged-page';

@Component({
    selector: 'app-push-history',
    templateUrl: './push-history.component.html',
    styleUrls: ['./push-history.component.scss'],
    standalone: false
})
export class PushHistoryComponent extends BasePagedPage<string, PushHistoryItemModel> implements OnInit {

  public constructor(private mApiService: ApiService) {
    super();
  }

  public getData(page?: number | undefined): void {
    if (!page) { return; }

    this.isBusy = true;

    this.mApiService.get<PagedResponseModel<PushHistoryItemModel>>(`/api/admin/push/history/${page}`).subscribe({
      next: r => {
        this.items = r.items;

        if (r.items) {
          for (const item of r.items) {
            item.date += '+00:00';
          }
        }

        this.page = page;
        this.pages = r.pages;

        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  ngOnInit(): void {
    this.getData(1);
  }

}

